<div class="row" *ngIf="title">
    <div class="col-12">
        <h3>{{title}}</h3>
    </div>
</div>

<app-report-common-options-input-form *ngIf="formGroup"
                                      [officeId]="officeId"
                                      [userId]="userId"
                                      [formGroup]="commonFormGroup"></app-report-common-options-input-form>
<div class="row">
    <app-form-field label="Envoyer par voie postale">
        <app-checkbox-input [parentFormGroup]="formGroup" parentFormControlName="sendByMail" (changeEvent)="sendByMailChanged()"></app-checkbox-input>
    </app-form-field>
</div>

<ng-container *ngIf="formGroup.get('recipient')">
    <app-service-container [service]="partnerFindOneByIdService"
        [loadingMessage]="undefined">
        <app-report-recipient-input-form [formGroup]="recipientFormGroup" [initialValue]="recipientPayload"></app-report-recipient-input-form>
    </app-service-container>
</ng-container>

